// extracted by mini-css-extract-plugin
export default {"forgetPassword":"ResetPassword_forgetPassword__e2RNv","forgetPassword__container":"ResetPassword_forgetPassword__container__M3esM"};